<template>
    <div>
        <span @click="getAllpfList" style="color:blue;font-size:13px;cursor: pointer;">【点击刷新】</span>
        <vggrid :list="psuList" tableheight="600" flexname="" :cols="cols"
                :canbeEdit="iscanbeEdit"
                :showfooter="false" :showPage="false" :resizable="true"
                :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
        >
        </vggrid>
        <div class="btn">
          <div>
            <el-button type='primary' style="width:200px;" @click="saveSeq" v-if="iscanbeEdit">提交</el-button>
          </div>
        </div>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exExpertScoreSummary',
    components: {vggrid},
    data () {
      return {
        project: {},
        psuList: [],
        pgstList:[],
        pexertList:[],
        btnLoading: false,
        pexpertInfo:{},
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          {field: 'comfullname', fieldtype: 'I', title: '供应商',width:300, calculExpr: '',width:150},
          {
            title: '项目评分',
            children: [
            ]
          }
          // {field: 'psas', fieldtype: 'I', title: '最终得分', calculExpr: ''},
          // {field: 'psseq', fieldtype: 'I', title: '排名', calculExpr: ''},
          // {field: 'psdesc', fieldtype: 'I', title: '意见', calculExpr: '', editRender: { name: 'input'}}
        ],
        iscanbeEdit:true
      }
    },
    created () {
      this.getModel()
      this.getPexertInfo()
      this.getAllpfList()
    },
    props:{
      activeName: {}
    },
    activated(){
    },
    mounted(){
    },
    deactivated () {
      this.$destroy()
    },
    watch:{
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'pfhz') {
            this.getModel()
        }
      }

    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        
      },
      async getAllpfList(){
        await this.getModel ()
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            projectisqcheck: this.project.projectisqcheck,
            psupqcesresult: 1
          }
        })
        // if(+this.project.projectisqcheck === 1){
        //     this.psuList = data.psuList.filter(e => {
        //         return e.psupqcesresult == 1
        //     })
        // }
        // else{
        //
        // }
        this.psuList = data.psuList.map((item) => {
          if (!item.psdesc) item.psdesc = '同意评分汇总结果'
          return item
        })
        this.pgstList = data.pgstList
        console.log(this.psuList.length)
        this.pexertList = data.pexertList
        if(this.cols.length < 3){
          this.setCrossCols(data)
        }
            this.totalScore(this.pgstList)
      },
      async setCrossCols(res){
          if(res.pexertList.length > 0){
            for(let i = 0;i < res.pexertList.length;i++){
              let item = res.pexertList[i]
              this.cols[1].children.push({
                  title:item.pexpertname ==  null?item.pexpertlogincode:item.pexpertname,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      return this.getCrossCheckResultDesc({pexpertid:item.pexpertid,psucomid:row.psucomid})
                    }
                  }
              })
            }
          }
          // this.cols.push({field: 'psuoffertime', fieldtype: 'I', title: '最终报价时间',width:100, calculExpr: ''})
          this.cols.push({field: 'Avg', fieldtype: 'I', title: '评审分',width:80, calculExpr: ''})
          this.cols.push({field: 'psupriceasexchange', fieldtype: 'I', title: '价格分',width:80, calculExpr: ''})
          this.cols.push({field: 'psas', fieldtype: 'I', title: '最终得分',width:80, calculExpr: ''})
          this.cols.push({field: 'psseq', fieldtype: 'I', title: '排名',width:60, calculExpr: ''})
          this.cols.push({
            title: '意见',
            slots: {
            default: 'default',
            default: ({row}) => {
              // row.psdesc='同意评审结果'
              if(this.iscanbeEdit)
                return [<el-input v-model={row.psdesc}></el-input>]
              else
                return row.psdesc
            }
          }})
          if (+this.project.projectdoneflg === 5) {
            const len = this.cols.length
            this.cols.splice(len - 3, 0, {field: 'psuperformanceas', fieldtype: 'I', title: '履约分',width:100, calculExpr: ''})
          }
      },
      getCrossCheckResultDesc(item){
          let code = this.pgstList.filter(v => +v.pgsexpertid === +item.pexpertid && +v.pgscomid === +item.psucomid)
          let i = code.length > 0 ? code[0].pgscommercialasexchange:''
          return i
      },
      totalScore(e){
        let k = 0
        for(let i = 0;i < this.psuList.length; i++){
          let sum = 0
          console.log(this.pgstList.length, 'this.pgstList.length')
          for(let j = 0;j <this.pgstList.length; j++){
              if(this.psuList[i].psucomid === this.pgstList[j].pgscomid){
                sum += Number(this.pgstList[j].pgscommercialasexchange)
              }
          }
          let sumAvg = Number(sum/this.pexertList.length) + Number(this.psuList[i].psupriceasexchange)
          if (+this.project.projectdoneflg === 5 && !isNaN(this.psuList[i].psuperformanceas)) {
            sumAvg += +this.psuList[i].psuperformanceas
            this.psuList[i].psperformanceas = +this.psuList[i].psuperformanceas // 履约分
          }
          this.psuList[i].psas = sumAvg.toFixed(2) //总得分
          this.psuList[i].pscommercialasexchange = Number(sum/this.pexertList.length).toFixed(2) //评审分
          this.psuList[i].psppriceasexchange = this.psuList[i].psupriceasexchange//价格分
          this.psuList[i].Avg = Number(sum/this.pexertList.length).toFixed(2)   //平均分
        }
        let z = 0
        for(let i = 0;i < this.psuList.length;i++){
            for(let j =0;j <this.psuList.length;j++){
                  if(Number(this.psuList[i].psas) < Number(this.psuList[j].psas)){
                    z++
                  }
                  if(Number(this.psuList[i].psas) === Number(this.psuList[j].psas) && Number(this.psuList[i].psupriceasexchange) < Number(this.psuList[j].psupriceasexchange)){
                    z++
                  }
                  if(Number(this.psuList[i].psas) === Number(this.psuList[j].psas) 
                  && Number(this.psuList[i].psupriceasexchange) === Number(this.psuList[j].psupriceasexchange)
                  && this.psuList[i].psuoffertime > this.psuList[j].psuoffertime){
                    z++
                  }
                // }
            }
              this.psuList[i].psseq = z+1
              z = 0
        }
        if (+this.project.projectdoneflg === 5) {
          this.psuList = this.psuList.sort((a,b) => a.psseq - b.psseq)
        }
        this.getpsrecList()
      },
      async getpsrecList(){

        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params:{psprojectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        if(prsList.length>0){
          this.iscanbeEdit = false
          this.psuList.forEach(e => {
              e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          });
        }

      },
      async saveSeq(){
        this.loading = true
        let pexerISstatus = this.pexertList.filter(v=>{
          return +v.pexpertpgsstatus === 2
        })
        if(this.pexertList.length !== pexerISstatus.length){
          this.$message.warning('尚有评审人未评分，请等候或者催促评审人评分');
          return
        }
          this.$confirm(`提交后不可修改，是否继续？`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {

                this.psuList.forEach(e=>e.psexpertid = this.$store.getters.expertLoginUser.pexpertid)
                let data = await request({
                  method: 'post',
                  url: 'expert/saveSeq',
                  data:this.psuList
                })

                if(data.issuccess === 1){
                  this.$message.success('提交成功')
                  await this.regNotice()
                  this.totalScore(this.pgstList)
                }

              }).catch(() => {
          })

        this.loading = false
      },
      async regNotice(){
          let model = {}
          model.projectid = this.$store.getters.expertLoginUser.pexpertprojectid
          model.cosid = this.$store.getters.expertLoginUser.cosid

          await request({
              url: 'expert/scoringSummarypush',
              method: "post",
              data: model
          })
      },
      async cellClick (row) {
        console.log(row)
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn{
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 30px 0;
}
</style>
